import { ConfigInterface } from '../interfaces/config.interface';

export const APP_CONFIG: ConfigInterface = {
  ssl: true,
  version: '0.42.85',
  ssr_port: 80,
  ssr_host: 'www.omega2k.de',
  api_port: 80,
  api_host: 'api.omega2k.de',
  logger: 'ERROR',
  socket: 'wss://api.omega2k.de',
  api: 'https://api.omega2k.de',
  url: 'https://www.omega2k.de',
  hash: "bb8945cc",
  nonce: "2ebccb008e1ef5ddae8016ee",
  wsServer: {
    ping: 60_000,
    heartbeat: 120_000,
    health: 600_000,
    fps: 15,
  },
};
